export default {
    "welcome": {
        "title": "Bem-vindo ao ProcrastiQ",
        "subtitle": "Seu companheiro de produtividade",
        "modal": {
            "title": "Bem-vindo ao ProcrastiQ",
            "headline": "Pausas inteligentes para seu c?rebro",
            "subheading": "Lanches cerebrais, curiosidades e momentos de aten??o plena que transformam minutos livres em algo significativo.",
            "text": "Procrastiq ? onde a procrastina??o se torna algo significativo. Em vez de rolar infinitamente pelas redes sociais, voc? descobrir? lanches cerebrais r?pidos projetados para entreter, estimular sua mente e talvez at? ensinar algo novo.\n\nN?o se trata de produtividade a qualquer custo. Todos precisam de um momento para pausar, recarregar e se afastar do trabalho. Procrastiq ajuda voc? a transformar essas pequenas pausas em algo positivo ? cheio de curiosidade, divers?o e treino cerebral di?rio. Pequenos desafios. Grande progresso.",
            "cta": "Vamos l?"
        }
    },
    "login": {
        "title": "Entrar",
        "email": "Email",
        "password": "Senha",
        "submit": "Entrar",
        "cancel": "Cancelar",
        "success": "Login bem-sucedido",
        "lead": "Bem-vindo de volta ? continue sua sequ?ncia e suba nas ligas."
    },
    "logout": "Sair",
    "logo": {
        "title": "ProcrastiQ",
        "slogan": "Pausas inteligentes para seu c?rebro"
    },
    "register": {
        "title": "Registrar",
        "name": "Nome",
        "email": "Email",
        "password": "Senha",
        "submit": "Criar conta",
        "cancel": "Cancelar",
        "success": "Cadastro realizado com sucesso",
        "country": "Pa?s",
        "lead": "Crie uma conta para ganhar XP, desbloquear patentes e participar de ligas semanais."
    },
    "social": {
        "divider": "Ou continue com",
        "signInWith": "Entrar com {{provider}}",
        "continueWith": "Continuar com {{provider}}",
        "failed": "Falha no login social",
        "popup_blocked": "O pop-up foi bloqueado. Por favor, permita pop-ups e tente novamente.",
        "cancelled": "O login foi cancelado."
    },
    "common": {
        "cancel": "Cancelar",
        "saving": "Salvando...",
        "unknown_error": "Erro desconhecido",
        "select_country": "Selecionar pa?s",
        "select_option": "Selecione uma op??o",
        "country": "Pa?s"
    },
    "language": {
        "page_language": "Idioma da p?gina",
        "switch_to": "Mudar para {{language}}"
    },
    "cookies": {
        "title": "Cookies",
        "message": "Usamos cookies de anal?tica (Google Analytics) para melhorar o Procrastiq.",
        "privacy_link": "Pol?tica de privacidade",
        "accept": "Aceitar",
        "reject": "Recusar"
    },
    "footer": {
        "columns": {
            "about": {
                "title": "Sobre n?s",
                "mission": "Miss?o",
                "progression": "XP, n?veis & ligas",
                "creator_progression": "XP e patentes de criadores",
                "contact": "Contate-nos"
            },
            "leaderboards": {
                "title": "Classifica??es",
                "players": "Membros",
                "creators": "Contribuidores"
            },
            "legal": {
                "title": "Privacidade & Termos",
                "community": "Diretrizes da comunidade",
                "terms": "Termos de servi?o",
                "privacy": "Pol?tica de privacidade"
            },
            "social": {
                "title": "Social",
                "facebook": "Facebook",
                "instagram": "Instagram"
            }
        }
    },
    "pages": {
        "mission": {
            "title": "Miss?o",
            "content": "ProcrastiQ transforma pequenas pausas em momentos significativos ? lanches cerebrais, quebra-cabe?as e pausas conscientes que entret?m e estimulam sua mente. \n\nAcreditamos que procrastinar n?o precisa ser tempo desperdi?ado. Todos merecem um momento para recarregar, e ajudamos a tornar esses momentos positivos, curiosos e divertidos. "
        },
        "contact": {
            "title": "Contacte-nos",
            "content": "Tem uma pergunta, uma ideia de melhoria ou encontrou algo que n?o funciona como deveria? Fale connosco ? cada feedback nos ajuda a melhorar ainda mais o Procrastiq.\n\nPode escrever-nos para:\n\nhello@procrastiq.com\n\nTamb?m teremos prazer em ler as suas sugest?es de novos conte?dos, funcionalidades ou temas que gostaria de ver no Procrastiq."
        },
        "community": {
            "title": "Diretrizes comunit?rias",
            "content": "ProcrastiQ ? um espa?o acolhedor para mentes curiosas. Seja respeitoso, gentil e construtivo nas suas intera??es. \n\nN?o poste conte?do prejudicial, abusivo ou de spam. Denuncie qualquer coisa que n?o perten?a. Juntos, mantemos este um lugar positivo para aprender e tirar pausas inteligentes. "
        },
        "terms": {
            "title": "Termos de servi?o",
            "content": "**?ltima atualiza??o: 7 de setembro de 2026**\n\nAo utilizar o servi?o Procrastiq, aceita estes termos. Se n?o concordar, n?o utilize o servi?o.\n\n## 1. Sobre o Procrastiq\n\nO Procrastiq ? uma plataforma online centrada na aprendizagem, question?rios, puzzles e outros conte?dos interativos.\n\nO conte?do do servi?o destina-se principalmente ? educa??o e ao entretenimento. N?o constitui aconselhamento profissional, jur?dico, m?dico, financeiro ou outro aconselhamento especializado.\n\n## 2. Conta de utilizador\n\nAlgumas funcionalidades do Procrastiq podem exigir a cria??o de uma conta de utilizador.\n\n? respons?vel pela exatid?o das informa??es da sua conta e pela prote??o das suas credenciais de acesso.\n\nUma conta n?o deve ser usada para violar direitos de terceiros, a lei aplic?vel ou estes termos.\n\n## 3. Regras de utiliza??o\n\nAo utilizar o Procrastiq, n?o ? permitido, em particular:\n\n* publicar conte?do ilegal, fraudulento, de ?dio ou de outra forma prejudicial,\n* violar direitos de autor ou outros direitos de terceiros,\n* assediar outros utilizadores,\n* tentar perturbar a seguran?a ou o funcionamento do servi?o,\n* recolher conte?do ou dados de forma automatizada de maneiras que n?o permitimos,\n* abusar de classifica??es, XP, rankings ou outros mecanismos de jogo.\n\n## 4. Conte?do do utilizador\n\nOs utilizadores podem criar ou enviar o seu pr?prio conte?do, como question?rios, perguntas, coment?rios ou outras contribui??es.\n\nAo enviar conte?do, confirma que tem o direito de o publicar.\n\nMant?m os seus direitos sobre o seu conte?do. Ao mesmo tempo, concede-nos um direito n?o exclusivo para o armazenar, apresentar, adaptar tecnicamente e disponibilizar no Procrastiq na medida necess?ria para operar o servi?o.\n\n## 5. Modera??o de conte?do\n\nPodemos rever o conte?do dos utilizadores e, se estes termos ou a lei aplic?vel forem violados, recus?-lo, ocult?-lo ou remov?-lo.\n\nEm casos graves ou repetidos, podemos restringir ou cancelar uma conta de utilizador.\n\nQuando as circunst?ncias o permitirem e a lei o exigir, informaremos o utilizador do motivo dessa decis?o.\n\n## 6. Conte?do do Procrastiq\n\nO conte?do publicado diretamente pelo Procrastiq pode conter erros ou imprecis?es. Embora procuremos verificar e melhorar continuamente a informa??o, n?o podemos garantir a sua integridade ou aus?ncia de erros.\n\nOs question?rios e outros conte?dos educativos t?m principalmente car?ter informativo e recreativo.\n\n## 7. Disponibilidade do servi?o\n\nProcuramos manter o Procrastiq dispon?vel e funcional, mas n?o podemos garantir um funcionamento ininterrupto ou sem erros.\n\nPodemos alterar, alargar ou descontinuar partes do servi?o ao longo do tempo.\n\n## 8. Responsabilidade\n\nNa medida permitida pela lei aplic?vel, n?o somos respons?veis por danos decorrentes do uso indevido do servi?o ou da confian?a em conte?do meramente informativo ou educativo.\n\nIsto n?o afeta os direitos dos utilizadores que n?o possam ser limitados nos termos da lei aplic?vel.\n\n## 9. Privacidade\n\nInforma??es sobre como tratamos dados pessoais est?o dispon?veis na nossa [Pol?tica de privacidade](/legal/privacy).\n\n## 10. Altera??es a estes termos\n\nPodemos atualizar estes termos de tempos a tempos, por exemplo devido a altera??es no servi?o, na lei ou no funcionamento do Procrastiq.\n\nA data da ?ltima atualiza??o aparecer? sempre no topo desta p?gina. Tamb?m podemos informar os utilizadores de altera??es significativas atrav?s do servi?o ou por e-mail.\n\n## 11. Contacto\n\nSe tiver perguntas sobre estes termos, pode contactar-nos em:\n\n[hello@procrastiq.com](mailto:hello@procrastiq.com)"
        },
        "privacy": {
            "title": "Pol?tica de privacidade",
            "content": "**?ltima atualiza??o: 7 de setembro de 2026**\n\nLevamos a sua privacidade a s?rio. Abaixo explicamos que dados pessoais tratamos quando usa o Procrastiq, porque precisamos deles e que direitos tem.\n\n## 1. Quem trata os dados\n\nO respons?vel pelo tratamento dos dados pessoais ?:\n\n**Michal Orl?k**\npessoa singular\n\nContacto para quest?es sobre prote??o de dados pessoais:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\n## 2. Que dados tratamos\n\nConsoante a forma como usa o Procrastiq, podemos tratar em particular:\n\n* dados da sua conta, por exemplo nome, nome de utilizador e endere?o de e-mail,\n* dados obtidos ao iniciar sess?o atrav?s de um servi?o externo, por exemplo Google,\n* informa??es sobre a utiliza??o do servi?o, por exemplo conte?do visualizado, resultados de question?rios, XP obtidos, sequ?ncias, rea??es, favoritos e atividade no feed,\n* conte?do que cria ou envia,\n* dados t?cnicos, por exemplo endere?o IP, tipo de dispositivo, navegador e informa??es necess?rias para a seguran?a e o correto funcionamento do servi?o.\n\n## 3. Porque usamos os dados\n\nUsamos os dados pessoais principalmente para:\n\n* criar e gerir a sua conta,\n* disponibilizar as funcionalidades do Procrastiq,\n* guardar o seu progresso, resultados, XP e outra atividade,\n* personalizar conte?do e recomenda??es,\n* proteger o servi?o contra abusos,\n* resolver erros e problemas t?cnicos,\n* comunicar consigo,\n* analisar e melhorar o funcionamento do servi?o.\n\n## 4. Base legal do tratamento\n\nTratamos os dados consoante cada finalidade principalmente:\n\n* porque s?o necess?rios para prestar o servi?o,\n* com base no nosso interesse leg?timo na seguran?a e melhoria do Procrastiq,\n* com base no seu consentimento quando o consentimento ? exigido,\n* ou para cumprir obriga??es legais.\n\nSe o tratamento assentar no consentimento, pode retir?-lo a qualquer momento.\n\n## 5. A quem os dados podem ser transmitidos\n\nN?o vendemos os seus dados pessoais.\n\nPara operar o servi?o, no entanto, podemos recorrer a prestadores externos, por exemplo para:\n\n* alojamento e infraestrutura,\n* autentica??o de utilizadores,\n* envio de e-mails e notifica??es,\n* anal?tica e diagn?stico de erros.\n\nEstes prestadores s? podem tratar os dados na medida necess?ria para prestar os seus servi?os.\n\n## 6. Durante quanto tempo conservamos os dados\n\nOs dados associados ? sua conta s?o geralmente conservados enquanto a conta existir e, depois, durante o tempo necess?rio para cumprir obriga??es legais ou proteger os nossos interesses leg?timos.\n\nOs dados t?cnicos e anal?ticos s?o conservados apenas durante o tempo necess?rio para a respetiva finalidade.\n\n## 7. Os seus direitos\n\nEm liga??o com o tratamento de dados pessoais, consoante as circunst?ncias tem o direito de:\n\n* obter informa??o sobre que dados tratamos a seu respeito,\n* solicitar a corre??o de dados inexatos,\n* solicitar o apagamento de dados,\n* solicitar a limita??o do tratamento,\n* opor-se a certas formas de tratamento,\n* receber os seus dados num formato port?vel,\n* retirar o consentimento concedido.\n\nPode enviar um pedido para:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\nRespondemos aos pedidos em conformidade com a legisla??o aplic?vel.\n\n## 8. Elimina??o da conta\n\nSe o servi?o permitir a elimina??o da conta, pode solicitar a remo??o diretamente nas defini??es da conta ou contactar-nos em **[hello@procrastiq.com](mailto:hello@procrastiq.com)**.\n\nAo eliminar a conta, removemos ou anonimizamos os dados pessoais que j? n?o precisamos de conservar por motivos legais ou de seguran?a.\n\n## 9. Cookies e tecnologias semelhantes\n\nO Procrastiq pode usar cookies e tecnologias semelhantes necess?rias para o in?cio de sess?o, a seguran?a, o armazenamento de defini??es e, eventualmente, a anal?tica.\n\nInforma??es mais detalhadas sobre cookies podem constar de uma pol?tica de cookies separada.\n\n## 10. Seguran?a\n\nUtilizamos medidas t?cnicas e organizativas adequadas para proteger os dados pessoais contra acesso n?o autorizado, perda ou utiliza??o indevida.\n\nNenhum sistema pode, no entanto, ser considerado absolutamente seguro.\n\n## 11. Reclama??o\n\nSe considerar que tratamos os seus dados pessoais em viola??o da legisla??o aplic?vel, tamb?m se pode dirigir ? autoridade de controlo competente.\n\nNa Rep?blica Checa, essa autoridade ? o **Gabinete para a Prote??o de Dados Pessoais (??ad pro ochranu osobn?ch ?daj?)**.\n\n## 12. Altera??es a esta pol?tica\n\nPodemos atualizar esta pol?tica de tempos a tempos, por exemplo em liga??o com novas funcionalidades ou altera??es legais.\n\nA data da ?ltima atualiza??o ser? sempre indicada no topo desta p?gina."
        },
        "progression": {
            "title": "XP, n?veis e ligas",
            "content": "ProcrastiQ recompensa a curiosidade. Responda quizzes, crie sequ?ncias e suba de petiscos casuais para a competi??o semanal. \n\n## Pontos de experi?ncia (XP)\n\nVoc? ganha XP permanente quando joga bem ? por exemplo, respostas corretas, b?nus de primeira tentativa, perguntas mais dif?ceis, avalia??es e objetivos di?rios. XP permanente nunca ? reiniciado e sempre conta para o seu n?vel. \n\nTamb?m existe XP ranqueado usado apenas para ligas semanais. XP ranqueado usa retornos decrescentes di?rios: XP inicial no dia conta totalmente, ganhos posteriores contam menos. Isso mant?m a competi??o justa se algu?m jogar o dia todo. \n\n## N?veis\n\nSeu n?vel vem do total de XP permanente. Cada n?vel precisa de um pouco mais de XP que o anterior (uma curva de crescimento), ent?o o progresso continua significativo.\n\nSeu perfil mostra quanto XP voc? tem no n?vel atual e quanto precisa para o pr?ximo.\n\n## Classifica??es de t?tulo\n\nAs classifica??es s?o t?tulos desbloqueados por n?vel. Eles s?o um s?mbolo de at? onde voc? chegou ? separado das divis?es da liga semanal.\n\n- N?vel 1 ? Mente Curiosa\n- N?vel 3 ? Explorador\n- N?vel 5 ? Pesquisador\n- N?vel 8 ? Solucionador de Problemas\n- N?vel 12 ? Analista\n- N?vel 18 ? L?gico\n- N?vel 25 ? Estrategista\n- N?vel 35 ? Pol?mata\n- N?vel 50 ? G?nio\n- N?vel 70 ? Mestre do Conhecimento\n- N?vel 100 ? Lenda Procrastiq\n\n## Ligas semanais\n\nAs ligas s?o uma competi??o semanal com outros jogadores em grupos de cerca de 20.\n\nDivis?es do menor para o maior:\n\n- Ferro\n- Bronze\n- Prata\n- Ouro\n- Platina\n- Diamante\n- Mestre\n- Lend?rio\n\nCada semana voc? compete com XP ranqueado dentro do seu grupo. No final da semana, aproximadamente os jogadores do topo promovem um n?vel e os jogadores da parte inferior rebaixam um n?vel. Todos os outros permanecem.\n\nVoc? n?o precisa esperar pelo reset de segunda-feira para entrar. Quando voc? se tornar eleg?vel, ser? colocado em um grupo aberto imediatamente ? ou um novo grupo ser? criado para voc?.\n\nPara desbloquear ligas voc? geralmente precisa:\n\n- pelo menos 100 XP permanente\n- pelo menos 10 atividades conclu?das\n- atividade em pelo menos 2 dias diferentes\n- visibilidade nos rankings ativada para seu perfil\n\nAbra a p?gina dos Rankings ou seu painel de estat?sticas a qualquer momento para ver sua divis?o, posi??o e grupo."
        },
        "creator_progression": {
            "title": "XP & classifica??es de Criador",
            "content": "Criar conte?do no ProcrastiQ tem sua pr?pria progress?o ? completamente separada do XP de jogador, n?veis e ligas semanais.\n\nQuando as pessoas gostam dos seus quizzes e alimentos cerebrais, voc? ganha XP de Criador (CXP). O CXP desbloqueia classifica??es de criador e te coloca nos rankings de Contribuidores.\n\n## Dois sistemas independentes\n\n- Progress?o do jogador ? XP por jogar, n?veis, classifica??es de t?tulo, ligas semanais\n- Progress?o do criador ? CXP por contribuir com conte?do de qualidade, classifica??es de criador, rankings de Contribuidores\n\nJogar n?o aumenta sua classifica??o de criador. Criar n?o aumenta seu n?vel de jogador. Voc? pode evoluir em ambos os caminhos ao mesmo tempo.\n\n## Como ganhar XP de Criador\n\nO CXP ? concedido por contribui??es aprovadas e pelo engajamento nesse conte?do ? n?o pela quantidade de rascunhos que voc? envia.\n\nRecompensas t?picas: \n\n- Conte?do aprovado ? +20 CXP (uma vez por item)\n- A cada 10 conclus?os do seu conte?do ? +2 CXP\n- A cada 10 curtidas no seu conte?do ? +5 CXP\n- A cada 10 favoritos no seu conte?do ? +2 CXP\n\nVisualiza??es e outras estat?sticas s?o acompanhadas no seu perfil de criador, mas apenas as recompensas acima concedem CXP. Os valores podem ser ajustados ao longo do tempo. \n\n## Patentes de criador\n\nSeu ranking de criador vem do CXP total. Os limiares crescem aproximadamente exponencialmente, ent?o o progresso inicial parece r?pido e os ranks mais altos continuam significativos. \n\n- 0 CXP ? Colaborador\n- 50 CXP ? Criador\n- 150 CXP ? Autor\n- 400 CXP ? Especialista\n- 1.000 CXP ? Mentor\n- 2.500 CXP ? Mestre Criador\n- 6.000 CXP ? Procrastiq Sage\n\nSeu perfil mostra seu ranking atual, CXP e progresso rumo ao pr?ximo posto. \n\n## Rankings de colaboradores\n\nCriadores s?o classificados pelo XP do Criador, n?o pelo n?mero de submiss?es. \n\n- Semanal ? CXP conquistado esta semana\n- Mensal ? CXP conquistado este m?s\n- Todos os Tempos ? CXP total\n\nAbra os Rankings e mude para Contribuidores para ver quem est? subindo. "
        }
    },
    "account": {
        "profile_picture": "Foto de perfil",
        "save_changes": "Altera??es de Salvamento",
        "update_success": "Perfil atualizado com sucesso",
        "update_failed": "N?o atualizou o perfil",
        "country": "Pa?s",
        "avatar": {
            "upload_label": "Upload Avatar",
            "upload_success": "Avatar enviado com sucesso",
            "upload_failed": "Falhou ao enviar avatar",
            "delete_confirm": "Voc? tem certeza de que quer deletar seu avatar? ",
            "delete_success": "Avatar deletado com sucesso",
            "delete_failed": "Falhou em deletar o avatar"
        },
        "password": {
            "set_optional": "Definir Senha (Opcional)",
            "change_optional": "Alterar Senha (Opcional)",
            "oauth_info": "Voc? fez login com {{method}}. Voc? pode opcionalmente definir uma senha para habilitar o login de e-mail/senha. ",
            "current": "Senha Atual",
            "current_placeholder": "Digite a senha atual",
            "current_required": "A senha atual ? necess?ria para mudar a senha",
            "new": "Nova senha",
            "set_placeholder": "Defina uma senha",
            "leave_blank_placeholder": "Deixe em branco para manter a atualiza??o",
            "confirm": "Confirmar Nova Senha",
            "confirm_placeholder": "Confirmar nova senha",
            "mismatch": "Novas senhas n?o coincidem"
        }
    },
    "play": {
        "label": "Play",
        "games": {
            "memory": "Memoria",
            "focus": "Foco",
            "sequence": "Sequencia",
            "reflex": "Reflexo"
        },
        "memory": {
            "hint_preview": "Lembra-te dos quadrados destacados.",
            "hint_input": "Toca nos quadrados de que te lembras.",
            "cell": "Quadrado {{n}}"
        },
        "focus": {
            "hint": "Encontra o simbolo diferente."
        },
        "sequence": {
            "title": "Memoriza a sequencia",
            "countdown_hint": "Prepara-te — a sequencia vai comecar.",
            "go": "Ja!",
            "hint_watch": "Olha com atencao.",
            "hint_input": "Agora repete a sequencia."
        },
        "reflex": {
            "hint": "Escolhe a cor, nao a palavra.",
            "progress": "{{current}} / {{total}}"
        },
        "colors": {
            "red": "VERMELHO",
            "blue": "AZUL",
            "green": "VERDE",
            "orange": "LARANJA"
        },
        "result": {
            "success": "Boa!",
            "fail": "✗ Errado."
        }
    },

    "pause": {
        "label": "Pausa",
        "types": {
            "breathing": "Respiracao",
            "eyes": "Pausa para os olhos",
            "stretch": "Alongamento rapido",
            "grounding": "Reset"
        },
        "skip": "Saltar",
        "continue": "Continuar",
        "breathing": {
            "inhale": "Inspira",
            "exhale": "Expira"
        },
        "eyes": {
            "step_far": "Olha para algo mais longe do ecran.",
            "step_blink": "Relaxa os olhos e pisca devagar varias vezes.",
            "step_close": "Fecha os olhos por um momento."
        },
        "stretch": {
            "step_shoulders": "Desce os ombros e deixa-os relaxar.",
            "step_sit": "Senta-te um pouco mais direito e relaxa as costas.",
            "step_roll": "Roda os ombros devagar."
        },
        "grounding": {
            "prompt_color": "Encontra 3 coisas a tua volta com a mesma cor.",
            "prompt_sounds": "Repara em 2 sons diferentes a tua volta.",
            "prompt_look_away": "Desvia o olhar do ecran durante alguns segundos.",
            "prompt_texture": "Toca em algo perto e sente a textura.",
            "prompt_breath": "Faz uma respiracao lenta e sente os pes no chao.",
            "prompt_feet": "Pressiona suavemente os pes no chao e sente o contacto."
        },
        "result": {
            "done": "Feito"
        }
    },

    "content": {
        "loading": "Carregando... ",
        "no_content": "Ainda n?o tem conte?do. ",
        "feed_exhausted_tag": "Voc? j? respondeu tudo para essa tag",
        "feed_exhausted_category": "Voc? j? respondeu tudo para essa categoria",
        "browse_feed": "Navegar pelo feed de conte?do",
        "back_to_feed": "? Voltar para alimentar",
        "back": "? De volta",
        "content_not_found": "Conte?do n?o encontrado",
        "failed_load": "N?o carregaram o conte?do",
        "failed_load_more": "N?o carreguei mais",
        "list": {
            "showing": "Mostrando {{count}} de {{total}}",
            "load_more": "Carregue mais"
        },
        "answer": {
            "your_answer": "Sua resposta... ",
            "your_result_or_answer": "Seu resultado ou resposta... ",
            "select_or_type": "Escolha sua resposta... ",
            "fill_in_blank": "Preencha o espa?o em branco... ",
            "your_answer_flip": "Sua resposta (ou virar para conferir)... ",
            "reveal_answer": "Resposta reveladora",
            "self_check_prompt": "Voc? sabia? ",
            "knew_it": "Eu sabia",
            "need_practice": "Preciso de mais pr?tica",
            "check": "Confere",
            "completed": "Conclu?do",
            "completing": "Salvando... ",
            "skip": "Pular",
            "next": "Pr?ximo",
            "checking": "Conferindo... ",
            "correct": "? Correto! ",
            "not_quite": "? Ainda n?o. ",
            "correct_answer": "Resposta correta: {{answer}}"
        },
        "stats": {
            "sign_in_to_react": "Fa?a login para curtir ou n?o curtir",
            "bookmark": "Marcador",
            "remove_bookmark": "Remover marcador",
            "save_for_later": "Guarde para depois",
            "saved": "Salvo",
            "share": "Compartilhe",
            "link_copied": "Link copiado para a prancheta",
            "share_failed": "N?o consegui compartilhar este quiz",
            "completions": "Conclus?o: {{count}}",
            "aria_like": "Tipo",
            "aria_dislike": "N?o gostar"
        },
        "admin": {
            "edit": "Editar",
            "delete": "Eliminar",
            "stats": "Estat?sticas",
            "stats_title": "Estat?sticas do conte?do",
            "delete_confirm": "Eliminar \"{{title}}\"?",
            "deleted": "Conte?do eliminado",
            "delete_failed": "Falha ao eliminar o conte?do",
            "load_failed": "Falha ao carregar o conte?do",
            "id": "ID",
            "slug": "Slug",
            "status": "Estado",
            "locale": "Idioma",
            "likes": "Gostos",
            "dislikes": "Nao gostos",
            "completions": "Conclusoes",
            "open_in_admin": "Abrir na administra?ao"
        },
        "difficulty": {
            "label": "Dificuldade: {{value}}/{{max}}",
            "value": "{{value}}/{{max}}",
            "aria": "Dificuldade {{value}} fora de {{max}}"
        },
        "detail": {
            "sign_in_to_answer": "Fa?a login para responder a essa pergunta. ",
            "duration": "Dura??o: {{minutes}} min",
            "phase": "Fase {{number}}"
        },
        "list_item": {
            "completions": "{{count}} conclus?o",
            "completions_label": "Conclus?o: {{count}}"
        },
        "feed": {
            "success": "Correto! ??",
            "skip": "Pular",
            "next": "Pr?ximo",
            "intro_gate": {
                "title": "Inicia sessão para continuar",
                "body": "Inicia sessão ou cria uma conta e o Procrastiq começa a adaptar-se ao que gostas.",
                "body_more": "Não vai repetir desnecessariamente as mesmas perguntas, lembra-se dos teus resultados e oferece conteúdo com base nos teus interesses.",
                "perks": "Também terás acesso a XP, ligas, Survival, desafios com outros jogadores e mais funcionalidades.",
                "register": "Criar conta",
                "login": "Iniciar sessão"
            }
        }
    },
    "categories": {
        "title": "Categorias",
        "filter": "Filtrar por categoria",
        "all": "Todos",
        "loading": "Carregando categorias... ",
        "empty": "Sem categorias",
        "expand": "Expandir subcategorias",
        "collapse": "Subcategorias de colapso"
    },
    "tags": {
        "title": "Tags",
        "all": "Todos",
        "loading": "Carregando etiquetas... ",
        "empty": "Sem tags"
    },
    "bookmarks": {
        "title": "Favoritos salvos",
        "empty": "Ainda n?o h? conte?do salvo. "
    },
    "contribute": {
        "title": "Contribuir",
        "subtitle": "Envie quizzes para revis?o. Uma vez aprovados, eles aparecem no feed. ",
        "subtitle_reliable": "Voc? ? um colaborador confi?vel ? seus quizzes v?o ao ar imediatamente. ",
        "add": "+ Enviar quiz",
        "add_first": "Envie seu primeiro quiz",
        "empty": "Voc? ainda n?o enviou nenhum conte?do. ",
        "load_failed": "N?o carreguei seu conte?do",
        "cannot_edit_approved": "Conte?do aprovado s? pode ser alterado por um administrador. ",
        "delete_confirm": "Apagar \"{{title}}\"? ",
        "deleted": "Conte?do exclu?do",
        "delete_failed": "Falhou em deletar conte?do",
        "edit": "Edit",
        "delete": "Excluir",
        "form": {
            "submit_title": "Envie um quiz",
            "edit_title": "Edite seu quiz",
            "submit_button": "Submeta para an?lise",
            "save_button": "Altera??es de salvamento",
            "hint": "Seu quiz ser? revisado antes de aparecer no feed. Colaboradores confi?veis s?o publicados imediatamente. ",
            "success_updated": "Conte?do atualizado com sucesso",
            "success_published": "Conte?do publicado com sucesso",
            "success_submitted": "Conte?do submetido para revis?o",
            "success_created": "Conte?do criado com sucesso",
            "success_translation": "Tradu??o criada com sucesso",
            "failed": "Falhou em {{action}} conte?do",
            "action_update": "Atualiza??o",
            "action_create": "criar",
            "choose_translation_language": "Escolha um idioma para a tradu??o. ",
            "admin_add": "Adicionar conte?do",
            "admin_edit": "Editar conte?do",
            "admin_add_translation": "Adicionar tradu??o",
            "admin_add_translation_lang": "Adicionar {{lang}} tradu??o",
            "admin_create": "Criar conte?do",
            "admin_update": "Conte?do de Atualiza??o",
            "admin_create_translation": "Criar tradu??o"
        }
    },
    "content_form": {
        "title": "T?tulo",
        "slug": "Slug",
        "language": "Idioma",
        "difficulty": "Dificuldade (1?5)",
        "country": "Pa?s",
        "status": "Status",
        "visibility": "Visibilidade",
        "categories": "Categorias",
        "tags": "Tags",
        "translations": "Tradu??es",
        "translation_new": "(novo)",
        "translate_hint": "Traduza a pergunta, as op??es e a explica??o. Metadados (dificuldade, categorias, tags) s?o copiados da fonte. ",
        "choose_language": "Escolha o idioma",
        "not_set": "N?o definido",
        "description": "Descri??o",
        "description_placeholder": "Descri??o da pergunta ou da tarefa",
        "options": "Op??es",
        "option_n": "Op??o {{n}}",
        "add_option": "+ Op??o de adicionar",
        "remove": "Remover",
        "correct_answer": "Resposta correta",
        "explanation": "Explica??o",
        "explanation_placeholder": "Opcional ? mostrado ap?s uma resposta errada"
    },
    "user_stats": {
        "title": "Seus Atributos",
        "sign_in_prompt": "Fa?a login para ver suas estat?sticas",
        "guest_title": "Classifica??o. Suba de n?vel. Suba de ligas. ",
        "guest_lead": "Rastree XP, desbloqueie rankings de t?tulo e participe de ligas semanais assim que voc? fizer login. ",
        "guest_perk_level": "Ganhe XP com quizzes e suba de n?vel. ",
        "guest_perk_rank": "Desbloqueie os rankings de t?tulo conforme seu n?vel sobe. ",
        "guest_perk_league": "Junte-se a grupos semanais e promova para o n?vel Lend?rio. ",
        "xp": "XP",
        "streak": "Streak",
        "best_streak": "Melhor sequ?ncia",
        "solved": "Respondido",
        "correct": "Correto",
        "accuracy": "Precis?o",
        "bookmarks": "Marcadores",
        "contribute": "Contribuir",
        "likes": "Gostos",
        "language_mastered": "Masterizado",
        "language_learning": "Aprendizado",
        "last_7_days": "?ltimos 7 dias",
        "days_suffix": "d",
        "no_activity": "Ainda sem atividade",
        "weekly_league": "Liga semanal",
        "league_tiers": "N?veis da liga",
        "league_tiers_hint": "Categorias do menor para o maior. Termine no topo do seu grupo para ser promovido; quem ficar na parte inferior ? rebaixado.",
        "league_position": "#{{position}} de {{total}} esta semana",
        "view_leaderboard": "Tabela completa",
        "how_leagues_work": "Como funciona",
        "you": "Voc?"
    },
    "gamification": {
        "level": "N?vel",
        "rank": "Classifica??o",
        "streak": "Sequ?ncia",
        "daily_goals": "Metas di?rias",
        "achievements": "Conquistas",
        "leaderboard": "Tabela de l?deres",
        "season": "Temporada",
        "xp_to_next": "{{current}} / {{next}} XP para o pr?ximo n?vel",
        "weekly": "Semanal",
        "monthly": "Este m?s",
        "overall": "Geral",
        "monthly_hint": "Classifica os jogadores pelo XP ranqueado ganho durante a temporada do m?s atual do calend?rio (mesmo retorno decrescente que nas ligas semanais). N?o ? uma categoria de liga separada.",
        "overall_hint": "Ranking geral pelo XP total permanente.",
        "overall_empty": "Nenhum jogador na tabela geral ainda.",
        "players": "membros",
        "full_board": "Tabela completa",
        "player": "Membro",
        "ranked_xp": "XP ranqueado",
        "total_xp": "XP total",
        "standing": "Posi??o",
        "zone": "Posi??o",
        "zone_promotion": "Promo??o",
        "zone_safe": "Seguro",
        "zone_relegation": "Rebaixamento",
        "zone_legend": "Os {{promo}} melhores s?o promovidos ? os {{releg}} piores s?o rebaixados ao final da semana.",
        "unlocked": "Desbloqueado",
        "achievements_error": "Falha ao carregar conquistas",
        "achievements_intro": "Desbloqueie emblemas enquanto joga ? atividade, precis?o, sequ?ncias, dificuldade e aprendizado com erros.",
        "achievement_categories": {
            "activity": "Atividade",
            "correct_answers": "Respostas corretas",
            "learning_from_mistakes": "Aprendizado com erros",
            "streaks": "Sequ?ncias",
            "difficulty": "Dificuldade",
            "variety": "Variedade",
            "general": "Geral"
        },
        "achievement_category_hints": {
            "learning_from_mistakes": "Ap?s uma resposta errada, aquele question?rio pode retornar depois para revis?o. Respond?-lo corretamente ent?o conta aqui."
        },
        "your_rank": "Sua classifica??o",
        "around_you": "Ao seu redor",
        "tooltip_total_xp": "{{xp}} XP total",
        "tooltip_level": "N?vel {{level}}",
        "weekly_waiting": "N?o foi poss?vel carregar seu grupo semanal. Por favor, tente novamente.",
        "weekly_ineligible": "Continue jogando para desbloquear ligas semanais.",
        "achievements_progress": "{{unlocked}} / {{total}} desbloqueados",
        "toast": {
            "xp_gained": "+{{xp}} XP",
            "achievement": "Conquista desbloqueada: {{name}}"
        },
        "level_up": {
            "title": "Subiu de n?vel!",
            "body": "Voc? alcan?ou o n?vel {{level}}",
            "continue": "Continue assim"
        }
    },
    "creator": {
        "rank": "Classifica??o de Criador",
        "xp": "XP do Criador",
        "tooltip_rank": "{{rank}}",
        "tooltip_cxp": "{{xp}} CXP",
        "approved": "Contribui??es aprovadas",
        "views": "Visualiza??es",
        "completions": "Conclu?dos",
        "likes": "Curtidas",
        "bookmarks": "Favoritos",
        "top_contribution": "Melhor contribui??o",
        "newest_contribution": "Contribui??o mais recente",
        "to_next": "para a pr?xima classifica??o",
        "players_board": "Membros",
        "creators_board": "Colaboradores",
        "board_group": "Tipo de tabuleiro",
        "weekly": "Semanal",
        "monthly": "Mensal",
        "all_time": "Todos os Tempos",
        "weekly_hint": "Criadores ranqueados por XP de criador conquistados esta semana. ",
        "monthly_hint": "Criadores ranqueados por XP de criador ganhos este m?s. ",
        "all_time_hint": "Ranking hist?rico por Creator XP. ",
        "empty": "Ainda n?o h? criadores no conselho. "
    },
    "profile": {
        "title": "Meu Perfil",
        "edit": {
            "title": "Editar Perfil"
        },
        "nav": {
            "label": "Conta",
            "overview": "Vis?o geral",
            "stats": "Estat?sticas",
            "leagues": "Ligas",
            "edit": "Editar perfil",
            "contribute": "Contribuir",
            "bookmarks": "Marcadores",
            "achievements": "Conquistas",
            "leaderboards": "Rankings",
            "browse": "Navegar pelo conte?do"
        },
        "actions": {
            "back_to_home": "De volta ao Lar",
            "back_to_profile": "Voltar ao Perfil",
            "edit": "Editar Perfil",
            "contribute": "Contribuir"
        },
        "labels": {
            "initials": "Iniciais",
            "role": "Fun??o",
            "status": "Status",
            "sign_in_method": "M?todo de Login",
            "member_since": "Membro desde",
            "country": "Pa?s",
            "reliable": "Colaborador confi?vel"
        },
        "sections": {
            "account_info": "Informa??es da Conta",
            "authentication": "Autentica??o",
            "creator": "Criador",
            "stats": "Seus dados",
            "leagues": "Ligas semanais"
        },
        "stats": {
            "title": "Estat?sticas",
            "subtitle": "Seu progresso, atividade e liga semanal em um olhar. ",
            "empty": "Ainda sem estat?sticas. Jogue alguns quizzes para come?ar. ",
            "periods": "Hoje e esta semana",
            "today": "Hoje",
            "see_all": "Todas as estat?sticas",
            "see_leagues": "P?gina de ligas abertas"
        },
        "leagues": {
            "title": "Ligas",
            "subtitle": "Sua divis?o semanal da liga, classifica??o de grupo e zona de promo??o ou rebaixamento. ",
            "your_group": "Seu grupo esta semana",
            "see_all": "Ligas abertas"
        }
    },
    "notifications": {
        "title": "Notifica??es",
        "hint": "Receba alertas sobre sua sequ?ncia, posi??o na liga e seu conte?do ? mesmo quando Procrastiq estiver fechado. ",
        "enable": "Ativar notifica??es",
        "disable": "Desative neste dispositivo",
        "enabled": "Notifica??es ativadas",
        "disabled": "Notifica??es desativadas neste dispositivo",
        "enable_failed": "N?o foi poss?vel ativar as notifica??es",
        "disable_failed": "N?o foi poss?vel desativar as notifica??es",
        "prefs_failed": "N?o foi poss?vel salvar as prefer?ncias",
        "unsupported": "Notifica??es push n?o s?o suportadas neste navegador. ",
        "pref_ranking": "Liga & classifica??o",
        "pref_streak": "Streak",
        "pref_reactions": "Rea??es ao meu conte?do",
        "pref_approved": "Aprova??o de conte?do"
    },
    "games": {
        "challenge_friend": "Challenge a friend",
        "survival_mode": "Survival",
        "challenges_inbox": "Challenges",
        "view_inbox": "View inbox",
        "pick_friend": "Pick a friend",
        "random_opponent": "Random opponent",
        "search_users": "Search by name?",
        "search_error": "Could not search users",
        "selected": "Selected",
        "selected_opponent": "Selected player",
        "pick_opponent": "Pick an opponent first",
        "random_hint": "We'll match you with an active player.",
        "any_category": "Any category",
        "category_optional": "Category (optional)",
        "start_challenge": "Send challenge",
        "challenge_created": "Challenge sent!",
        "create_error": "Could not create challenge",
        "challenge": "Challenge",
        "open": "Open",
        "new_challenge": "New challenge",
        "start_playing": "Start playing",
        "accept_play": "Accept & play",
        "decline": "Decline",
        "decline_error": "Could not decline challenge",
        "your_result": "Your result",
        "opponent_result": "Opponent",
        "waiting_opponent": "Waiting for your opponent to finish?",
        "score_line": "{{correct}}/{{total}} correct ? {{time}}",
        "you_won": "You won!",
        "you_lost": "You lost",
        "draw": "It's a draw",
        "submitting": "Submitting answers?",
        "submit_error": "Could not submit challenge",
        "load_error": "Could not load",
        "not_found": "Challenge not found",
        "no_challenges": "No challenges yet",
        "incoming": "Incoming",
        "outgoing": "Outgoing",
        "player": "Player",
        "filter": {
            "incoming": "Incoming",
            "outgoing": "Outgoing",
            "all": "All"
        },
        "status": {
            "pending": "Pending",
            "in_progress": "In progress",
            "completed": "Completed",
            "declined": "Declined",
            "expired": "Expired"
        },
        "question_progress": "Question {{current}} / {{total}}",
        "time_left": "{{seconds}}s",
        "elapsed_time": "Time {{time}}",
        "overall_time": "Total time",
        "total_time_left": "Total {{seconds}}s",
        "no_options": "No answer options for this question",
        "survival_leaderboard": "Survival leaderboard",
        "survival_leaderboard_hint": "Best survival run per player in the selected period.",
        "survival_empty": "No survival scores yet ? be the first!",
        "play_survival": "Play Survival",
        "current_score": "Score: {{score}}",
        "game_over": "Game over",
        "final_score": "You scored {{score}}",
        "personal_best": "Personal best: {{score}}",
        "daily_rank": "Daily rank: #{{rank}}",
        "weekly_rank": "Weekly rank: #{{rank}}",
        "play_again": "Play again",
        "survival_start_error": "Could not start survival run",
        "survival_error": "Survival error",
        "daily": "Daily",
        "weekly": "Weekly",
        "all_time": "All time",
        "score": "Score",
        "challenge_user": "Challenge {{name}}",
        "login_to_challenge": "Log in to challenge this player",
        "profile_error": "Could not load profile",
        "profile_not_found": "Player not found",
        "profile": "Profile",
        "notifications": "Notifications",
        "mark_all_read": "Mark all read",
        "no_notifications": "No notifications",
        "blocked_users": "Blocked players",
        "blocked_hint": "Blocked players cannot challenge you.",
        "no_blocked": "You haven't blocked anyone.",
        "unblock": "Unblock",
        "unblocked": "Player unblocked",
        "unblock_error": "Could not unblock player",
        "blocked_load_error": "Could not load blocked players",
        "survival_howto": "Responda corretamente o máximo de tempo possível. Tem 20 segundos por pergunta. Um erro é perdoado — o segundo termina a partida. A pontuação é o número de respostas certas.",
        "challenge_howto": "Dez perguntas, 20 segundos cada. Ganham mais acertos e um tempo mais rápido. Vê o resultado do adversário quando ambos tiverem terminado.",
        "continue": "Continuar",
        "survival_reserve": "Reserva: {{count}}",
        "survival_second_chance": "Segunda chance!",
        "guest_teaser": "Log in to challenge friends and climb Survival ranks."
    }
};
